import clsx from "clsx";
import shape from "../../assets/img/shapes/frame-shape-04.webp";


const FrameShape04 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-frame-shape-04", props.className)}>
            <img src={shape} alt="rmdr-frame-shape-04" loading="lazy" width={76} height={55} />
        </div>
    )

}

export default FrameShape04;
